@if (!loadComplete()) {
  <is-wait-message [loadComplete]="loadComplete()" [useBolt]="false" [waitMessage]="'Please wait while we process your request.'" [timeoutAmount]="0">
  </is-wait-message>
}

<div class="manage-payment-form-container">
  <div class="container bolt-container bolt-space-bottom-2xl">
    <bolt-progress-bar appFocusOnInit arialabel="add refund method progress value is 75%" class="progress-bar-container to-container" value="75"></bolt-progress-bar>
    <h1 class="bolt-heading-primary bolt-space-bottom-2xl">Add refund method: review & submit</h1>

    <div class="bolt-row">
      <div class="bolt-col-12">
        @if (disclaimerMessage | async; as message) {
          <section>
            <app-payment-sub-header>Refund details</app-payment-sub-header>
            <div class="recap-content bolt-space-bottom-2xl">
              @for (field of recapBankAccountFields; track field.id) {
                  <app-recap-form-field [field]="field"></app-recap-form-field>
              }
            </div>
            <app-payment-sub-header>Contact information</app-payment-sub-header>
            <div class="email-content bolt-space-bottom-2xl">
              <app-recap-form-field class="email-field" [field]="recapEmailAddressField"></app-recap-form-field>
            </div>
            <div class="notification-content">
              <bolt-notification type="info" class="to-container bolt-space-bottom-lg">
                <is-interpolate [text]="message"></is-interpolate>
              </bolt-notification>
            </div>
          </section>
        }
      </div>
    </div>
  </div>
  <bolt-button-bar>
    <is-button slot="cancel" id="cancel-button" (click)="cancelAddRefundMethod()">Cancel</is-button>
    <is-button slot="back" id="back-button" (click)="navigateToLanding()">Back</is-button>
    <is-button slot="forward" id="submit-button" type="solid" (click)="submit()">Submit</is-button>
  </bolt-button-bar>
</div>